'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cx } from '../../../internal/cx.js';
/** Non-modal floating panel for filters, pickers and quick edits. */
export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;
export const PopoverClose = PopoverPrimitive.Close;
export const PopoverContent = forwardRef(function PopoverContent({ className, sideOffset = 6, align = 'start', ...rest }, ref) {
    return (_jsx(PopoverPrimitive.Portal, { children: _jsx(PopoverPrimitive.Content, { ref: ref, sideOffset: sideOffset, align: align, ...rest, className: cx('mn-popover', className) }) }));
});
//# sourceMappingURL=popover.js.map